export function imageFromBuffer(data: number[]) {
	const buffer = String.fromCharCode.apply(null, data);
	const image = window.btoa(buffer);
	return `data:image/png;base64, ${image}`;
}